import type {Page} from "crqlar-react-common/dist/models/common/page.model";
import type {SurveyFeedbackTheme} from "crqlar-react-common/dist/models/survey/surveyFeedbackTheme.model";
import {SurveyService} from "crqlar-react-common/dist/services/survey/survey.service";
import {useQuery} from "react-query";
import {SURVEY_FEEDBACK_THEMES_QUERY_KEY} from "./surveyQueryRefresh";

// The only request under this key: the cache keeps the page the API sends, and this hook picks the themes out of it.
const THEME_LIST_LIMIT = 200;

const NO_THEMES: SurveyFeedbackTheme[] = [];

// Module level, so react-query sees the same select every render and maps a page only once.
const themesOf = (page: Page<SurveyFeedbackTheme>) => page.content ?? NO_THEMES;

/** The organisation's themes, archived ones left out: the theme filter, and the names the AI's labels point at. */
export function useSurveyFeedbackThemes(): {themes: SurveyFeedbackTheme[]; isLoading: boolean} {
    const query = useQuery(
        [SURVEY_FEEDBACK_THEMES_QUERY_KEY],
        () => SurveyService.listThemes({archived: false, limit: {offset: 0, limit: THEME_LIST_LIMIT}}),
        {refetchOnWindowFocus: false, select: themesOf}
    );

    return {themes: query.data ?? NO_THEMES, isLoading: query.isLoading};
}
